type IgnoreResultToast = {
  title: string;
  message: string;
  color: 'success' | 'warning' | 'error';
};

export function buildIgnoreResultToast(data: {
  ignored: number;
  failures: Array<{ error?: string }>;
}): IgnoreResultToast {
  const failureCount = data.failures.length;
  if (data.ignored === 0 && failureCount === 0) {
    return {
      title: 'No Invoices Ignored',
      message: 'No matching invoices were eligible to ignore',
      color: 'warning',
    };
  }
  if (failureCount === 0) {
    return {
      title: 'Invoices Ignored',
      message: `Ignored ${data.ignored} invoice${data.ignored !== 1 ? 's' : ''}`,
      color: 'success',
    };
  }
  if (data.ignored === 0) {
    return {
      title: 'Ignore Failed',
      message: data.failures[0]?.error || 'Failed to ignore invoices',
      color: 'error',
    };
  }
  return {
    title: 'Ignore Partially Complete',
    message: `Ignored ${data.ignored} invoice${data.ignored !== 1 ? 's' : ''}. ${failureCount} failed.`,
    color: 'warning',
  };
}
